import compose from "recompose/compose";
import withProps from "recompose/withProps";
import lifecycle from "recompose/lifecycle";
import withState from "recompose/withState";
import withHandlers from "recompose/withHandlers";
import isEqual from "lodash/isEqual";
import HeidelbergBook from "./HeidelbergBook";

const getSpread = (activePage) =>
  activePage % 2 === 0
    ? [activePage, activePage + 1]
    : [activePage - 1, activePage];

const enhance = compose(
  withState("activeSpread", "setActiveSpread", [0, 1]),
  withProps((props) => ({
    atFrontCover: isEqual(props.activeSpread, [0, 1]),
    atBackCover: props.activeSpread.includes(props.pages.length),
  })),
  withHandlers({
    handleIncrement: (props) => () => {
      const activePage = props.activePage + 2;
      if (activePage <= props.pages.length) {
        props.setActivePage(activePage);
      } else {
        props.setActivePage(props.pages.length);
      }
    },
    handleDecrement: (props) => () => {
      const activePage = props.activePage - 2;
      if (activePage >= 0) {
        props.setActivePage(activePage);
      } else {
        props.setActivePage(1);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const activePage = this.props.activePage;
      if (activePage >= 0 && activePage <= this.props.pages.length) {
        const spread = getSpread(activePage);
        this.props.setActiveSpread(spread);
      }
    },
    componentDidUpdate(prevProps) {
      const activePage = this.props.activePage;
      if (
        prevProps.activePage !== activePage &&
        activePage >= 0 &&
        activePage <= prevProps.pages.length
      ) {
        const spread = getSpread(activePage);
        this.props.setActiveSpread(spread);
      }
    },
  })
);

export default enhance(HeidelbergBook);
